import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const APPLICATION_UPDATE_RESOURCE = "application" as const;
export const APPLICATION_UPDATE_API_PATH = `/v1/${APPLICATION_UPDATE_RESOURCE}/{uuid}` as const;

export type ApplicationUpdateBody =
  paths[typeof APPLICATION_UPDATE_API_PATH]["patch"]["requestBody"]["content"]["application/json"];
export type ApplicationUpdateResponse =
  paths[typeof APPLICATION_UPDATE_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useApplicationUpdateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<ApplicationUpdateResponse, Error, ApplicationUpdateBody & { uuid: string }>({
    mutationFn: async (application: ApplicationUpdateBody & { uuid: string }) => {
      const { uuid, ...rest } = application;
      const response = await alphartisApiAxios.patch<ApplicationUpdateResponse>(
        `/v1/${APPLICATION_UPDATE_RESOURCE}/${uuid}`,
        rest,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [APPLICATION_UPDATE_RESOURCE],
      });
    },
  });
};
